export default __webpack_public_path__ + "static/media/startingsoon.6ac1e27f.svg";